export class DefaultLoginOptions {
    disableLogin: boolean;
    disableRegistration: boolean;
    urlRegistration: string;
    urlPasswordRecovery: string;
    usernameLabel: string;
    groups: string[];
    mfaByEmail: boolean;
    passwordRegex: string;
    passwordCustomRules: string;

    constructor(obj?) {
        obj = obj || {};
        this.disableLogin = obj.disableLogin || false;
        this.disableRegistration = obj.disableRegistration || false;
        this.urlRegistration = obj.urlRegistration || null;
        this.urlPasswordRecovery = obj.urlPasswordRecovery || null;
        this.usernameLabel = obj.usernameLabel || null;
        this.groups = obj.groups || [];
        this.mfaByEmail = obj.mfaByEmail || false;
        this.passwordRegex = obj.passwordRegex || null;
        this.passwordCustomRules = obj.passwordCustomRules || null;
    }
}
